const deleteCompaniesStr = {
  toastr: 'Empresa deletada',
  toastr1: ' deletado com sucesso'
};

export default deleteCompaniesStr;
